<script setup>
import axios  from "axios";
axios.defaults.baseURL = 'https://qlipper.jp/';
axios.defaults.withCredentials = true;
axios.defaults.crossDomain = true;
</script>
<template>
    <v-card
        v-if="doc_id!=''"
        min-height = "100vh"
        flat
    >
        <v-card-title class="py-1">
            <h2 style="margin-top:0px">{{ title }}</h2>
        </v-card-title>
        <v-card-text>
            <p>レビューをお願いする方を招待するためのURLを発行します。共有に必要なパスワードを入力して発行ボタンを押下してください。</p>
            <p>招待前に自動的に保存されます。</p>
        </v-card-text>
        <v-card-text>
            <v-form ref="test_form">
            <v-row>
            <v-col cols="5">
            <v-text-field
                v-model="password"
                dense
                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                :rules="form.rules"
                :type="show1 ? 'text' : 'password'"
                :counter="!noValidation"
                :hint="form.hint"
                :placeholder="form.placeholder"
                :hide-details="noValidation"
                @click:append="show1 = !show1"
            ></v-text-field>
            </v-col>
            <v-col>
                <v-btn
                    :disabled="check_flg"
                    @click="open()"
                >
                    <v-icon>
                        mdi-lock
                    </v-icon>
                    発行
                </v-btn>
            </v-col>
            </v-row>
            </v-form>
        </v-card-text>
		<v-card-text>
			<h2 class="editor_h2">赤入れ機能とは？</h2>
			<div class="videobox">
			<video src="share.mp4" controls muted width="700px"></video>
			</div>
		</v-card-text>
    </v-card>
</template>
<script>
export default {
    props: {
        noValidation: {
          type: Boolean,
          default: false
        }
    },
    computed : {
        form () {
            const min = '8文字';
            const msg = `${min}。半角英数字_-が使えます`;
            const required = v => !!v || ''
            const format = v => /^[\w-]{8,8}$/.test(v) || msg;
            const rules = this.noValidation ? [required] : [format];
            const hint = this.noValidation ? undefined : msg;
            const placeholder = this.noValidation ? undefined : min;
            return { rules, hint, placeholder };
        },

        title : function(){
            return this.$store.getters['doc_info/get_title'];
        },
        doc_id : function(){
            return this.$store.getters['doc_info/get_doc_id'];
        },
    },
    watch : {
        password : function(){
            if (this.$refs.test_form.validate()) {
                this.check_flg = false;
            }
            else
            {
                this.check_flg = true;
            }
        },
    },
    data : function(){
        return {
            password    : "",
            check_flg   : true,
            show1: false,
        };
    },
    methods : {
        open : async function(){
            this.$emit("docsave");
            if(this.doc_id=="")
            {
                this.act = true;
                return;
            }
            var params = new URLSearchParams();
            params.append("doc_id",this.doc_id);
            params.append("password",this.password);
            await axios.post("/api/release/get_shareurl",params)
            .then(response => {
                this.$store.commit("doc_info/set_uuid",response.data['uid']);
            });
        },
    },
    mounted : function(){
    },
}
</script>
